var _circle, _circle2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#FEF5DE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 16,
    fill: "#FFB900"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5137 24.1251C25.5137 22.5965 25.5137 21.0678 25.5137 19.5391C25.5137 18.6246 26.1188 17.9942 26.9856 18C27.8281 18 28.4235 18.6382 28.4235 19.5362C28.4235 22.6059 28.4235 25.6752 28.4235 28.7442C28.4235 29.6441 27.7882 30.3125 26.9525 30.3008C26.1168 30.2891 25.5146 29.6305 25.5137 28.7442C25.513 27.2058 25.513 25.6661 25.5137 24.1251Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9592 35.9998C26.5696 35.9983 26.1892 35.881 25.8663 35.663C25.5434 35.4449 25.2925 35.1359 25.1455 34.7751C24.9984 34.4143 24.9618 34.0179 25.0404 33.6363C25.1189 33.2546 25.309 32.9049 25.5865 32.6315C25.8641 32.358 26.2166 32.1731 26.5994 32.1003C26.9821 32.0275 27.3779 32.0699 27.7365 32.2223C28.0951 32.3747 28.4004 32.6302 28.6136 32.9563C28.8268 33.2824 28.9383 33.6645 28.9341 34.0541C28.9341 34.3121 28.8829 34.5675 28.7833 34.8055C28.6837 35.0435 28.5377 35.2593 28.3539 35.4404C28.1702 35.6214 27.9522 35.7641 27.7128 35.8602C27.4733 35.9562 27.2172 36.0037 26.9592 35.9998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alertIcon.5e85c7d59f58d2c927678c156092621b.svg";
export { ForwardRef as ReactComponent };